<template>
    <div>
        <div v-if="loading" class="text-center">
            <v-progress-circular indeterminate color="primary" :size="90"></v-progress-circular>
        </div>
        <v-card class="mt-6 pl-6 section" v-else>
            <v-card-title>
                <div class="text-h4 primary--text font-weight-light">Pricing Table</div>
            </v-card-title>
            <v-card-text class="card">
                <v-row>
                    <table>
                        <tr>
                            <td colspan="2"><h2 class="pl-6 pt-0 pb-2">Pricing Asumptions</h2></td>
                        </tr>
                        <tr v-for="(item) in selectedTokens.pricing_asumptions" :key="item.key">
                            <td class="text-subtitle-1 pl-6" style="width: 500px">{{ item.description }}</td>
                            <td class="text-subtitle-1 pl-6">{{ item.value }}</td>
                        </tr>
                        <tr>
                            <td colspan="2"><h2 class="pl-6 pt-0 pb-2">Setup Installations Fees</h2></td>
                        </tr>
                        <tr v-for="(item) in selectedTokens.setup_installations_fees" :key="item.key">
                            <td class="text-subtitle-1 pl-6" style="width: 500px">{{ item.description }}</td>
                            <td class="text-subtitle-1 pl-6">{{ item.value }}</td>
                        </tr>
                        <tr>
                            <td colspan="2"><h2 class="pl-6 pt-0 pb-2">Annual Fees</h2></td>
                        </tr>
                        <tr v-for="(item) in selectedTokens.annual_fees" :key="item.key">
                            <td class="text-subtitle-1 pl-6" style="width: 500px">{{ item.description }}</td>
                            <td class="text-subtitle-1 pl-6">{{ item.value }}</td>
                        </tr>

                    </table>
                </v-row>
            </v-card-text>
        </v-card>


    </div>
</template>

<script>

import { defaultTokenList } from '../store/global_helpers/utility';
import axios from 'axios';

export default {
    async mounted(){
        this.loading = true
        await this.loadSavedTokens()
        this.loading = false
    },

    data: () => ({
        tablePricing: defaultTokenList(),
        loading: true,
        selectedTokens: undefined

    }),
    methods:{
        async loadSavedTokens() {
            let token = sessionStorage.getItem('token');
            let authToken = "Token "+token;
            let authHeader = {headers: {
                Authorization: authToken
            }};
            try{
                const proposalId = this.$route.params.proposal_id
                const resp = await axios.get(`pricing_table/selected_tokens/?proposal_id=${proposalId}` , authHeader)
                let formatedSelectedTokens = resp.data.selectedTokens
                formatedSelectedTokens.pricing_asumptions = resp.data.selectedTokens.pricing_asumptions.map(v => {
                    v.key = this.uuidv4()
                    return v
                })
                formatedSelectedTokens.setup_installations_fees = resp.data.selectedTokens.setup_installations_fees.map(v => {
                    v.key = this.uuidv4()
                    return v
                })
                formatedSelectedTokens.annual_fees = resp.data.selectedTokens.annual_fees.map(v => {
                    v.key = this.uuidv4()
                    return v
                })
                this.selectedTokens = formatedSelectedTokens
                this.loading = false
            }catch(err) {
                console.log(err)
            }
        },
        uuidv4() {
          return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
          });
        }
    }
}
</script>